module.exports = __webpack_public_path__ + "img/everli-logo.69171fe1.png";